import React from "react";
import { APIKey, FormSectionElements, FormSections, LOVValues, ProgramContainer } from "../../entities/formTemplateDataType";
import classNames from 'classnames';
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import axios from "axios";
import SessionStorageService from "../../services/SessionStorageService";
import DataUtils from "../../utilities/DataUtils";
import { TOKEN_TYPE } from "../../entities/Constants";
import Utils from "../../utilities/Utils";
import { displayField, getRootComponent, triggerSummaryListFilter, isSummaryLinked, updateFilterSelectionCode } from "../../utilities/ElementUtils";
import { setBaseHeaders } from "../../utilities/submitUtils";
import { SpinnerComponent } from "../../commonComponent/SpinnerComponent";
import { getEnvVar, SCRIPT_ENV } from "../../config/RuntimeConfig";
import { resolveApiUrl } from "../../utilities/URLUtils";
import { getViewportSize } from "../../utilities/HtmlUtils";


interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  optionsFieldValue?: Map<string, string>;
  callbackElement;
  isEng: boolean;
  usedForFilter;
}

interface State {
  isBusy: boolean;

}
export class DropdownComponent extends React.Component<Props, State> {

  ignoreNextDropdownChange: boolean = false;

  constructor(props: Props) {
    super(props);

    this.state = {
      isBusy: false
    };

    let field = this.props.field;
    let programContainer: ProgramContainer = getRootComponent(field);
    field.IsDirty = false;
    FormValidationUtils.runJavascript(field);
  }

  async componentDidMount(): Promise<void> {
    // Expose a callback for PagedSummaryListComponent to trigger re-render when options are updated
    const fieldAny = this.props.field as any;
    if (fieldAny?.filterSummaryListId) {
      fieldAny._optionsUpdated = () => {
        this.forceUpdate();
      };

      // If PagedSummaryList has already fetched data and we have no options yet,
      // trigger the PagedSummaryList to rebuild options for this dropdown
      if ((!fieldAny.ListOfLOVValues || fieldAny.ListOfLOVValues.length === 0)) {
        // Find the linked PagedSummaryList and trigger option rebuild
        const root = getRootComponent(this.props.field);
        const sections = root?.ListOfFormSections ?? [];

        const findAndRebuild = (elements: any[]): boolean => {
          for (const element of elements ?? []) {
            if (element.Id === fieldAny.filterSummaryListId && element._rebuildAutocompleteOptions) {
              element._rebuildAutocompleteOptions();
              return true;
            }
            if (element.subSectionList?.length) {
              for (const sub of element.subSectionList) {
                if (findAndRebuild(sub?.ListOfFormSectionElements)) return true;
              }
            }
          }
          return false;
        };

        for (const section of sections) {
          for (const subSection of section.ListOfFormSubSections ?? []) {
            if (findAndRebuild(subSection.ListOfFormSectionElements)) break;
          }
        }
      }
    }

    await this.getDropdownList();
    let field = this.props.field;

    //if (!field.Value ||this.props.field.Value === undefined) {
    //  this.props.field.Value = this.props.field.ListOfLOVValues[0].code;
    //}

    const hasNoValue = field.Value === undefined || field.Value === null || field.Value === '';
    if (hasNoValue) {
      const lovOptions = this.applyFilter(field);
      const visibleLovOptions = lovOptions.filter((option) => (option.Visible === undefined || option.Visible));
      const hasEmptyItem = field.AddEmptyItemToList === 'Y';

      if (hasEmptyItem) {
        if (field.Value !== '') {
          field.Value = '';
          let programContainer = getRootComponent(field);
          this.props.callbackElement(programContainer);
        }
      } else if (visibleLovOptions.length > 0 && visibleLovOptions[0].code) {
        field.Value = visibleLovOptions[0].code;
        let programContainer = getRootComponent(field);
        this.props.callbackElement(programContainer);
      }
    }

    try {
      FormValidationUtils.runJavascript(field);
    } catch (ex) {
      console.log(ex);
    }

  }

  getDropdownList = async () => {
    let field = this.props.field;
    let programContainer: ProgramContainer = getRootComponent(field);

    if (field.LovAPI) {
      try {
        // if(programContainer.AuthRequired=='ps'){
        //   const psToken=SessionStorageService.getPSToken();
        //   if(psToken){
        //     axios.defaults.headers.common['Authorization'] = `Bearer ${psToken}`;
        //   }
        // } else {
        //    const accessToken = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
        //     axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        //       console.log("accessToken", accessToken);
        // }

        const apiKey: APIKey = (programContainer.ApiKeyKey && programContainer.ApiKeyValue) ? { key: programContainer.ApiKeyKey, value: programContainer.ApiKeyValue } : null;

        const authToken = SessionStorageService.getAuthToken(programContainer.AuthRequired) ?? programContainer.Profile?.token;
        const headers = setBaseHeaders('application/json', authToken, apiKey);

        const configs = {
          ...{ headers },  // Headers
          withCredentials: true
        }
        let url = programContainer.APIBasePath + "/" + field.LovAPI;

        if (field.LovAPI.startsWith("http://") || field.LovAPI.startsWith("https://")) {
          url = resolveApiUrl(field.LovAPI);
        }

        this.setState({ isBusy: true });
        const response = await axios.get(url, configs);
        this.setState({ isBusy: false });

        field.ListOfLOVValues = [];
        if (Array.isArray(response.data)) {
          const lovValues = response.data.map(item => {
            const lov = new LOVValues();
            lov.code = item.code;
            lov.description = item.description;
            lov.FRADescription = item.FRADescription;
            lov.parent = field;
            return lov;
          });
          field.ListOfLOVValues.push(...lovValues);
        }
        this.reconcilePreBoundValueWithLovOptions(field);
      } catch (ex) {
        console.log(ex);
      }
    }
  }

  getProgramContainer = async () => {
    const field = this.props.field;
    let programContainer = getRootComponent(field) as ProgramContainer;

    const accessToken = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
    if (programContainer.APIBasePath && programContainer.GetAPI) {
      let url = programContainer.APIBasePath + "/" + programContainer.GetAPI;
      if (field.Value) {
        url = url + "/" + field.Value
      }
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        }
      });

      return response.data;
    }
    return null;
  }

  onDropdownChangeOnDialog = async (e) => {
    let field = this.props.field;
    if (field.ReadOnly) {
      e?.preventDefault?.();
      return;
    }

    if (field.MultipleSelectionsProps?.allowMultipleSelection && this.ignoreNextDropdownChange) {
      this.ignoreNextDropdownChange = false;
      return;
    }

    if (field.MultipleSelectionsProps?.allowMultipleSelection) {
      field.Value = [];
      const options = e.target.options;
      for (let i = 0; i < options.length; i++) {
        if ((options[i].selected) && (options[i].value !== 'Select')) {
          field.Value.push(options[i].value);
        }
      }
    } else {
      field.Value = e.value || e.target.value || e.originalEvent?.target.value;
      if (field.Value === 'Select') field.Value = null;
    }

    FormValidationUtils.markFieldDirty(field);

    try {
      FormValidationUtils.validateDropdown(field)
      FormValidationUtils.runJavascript(field);

      if (field.EventScript && Utils.isNotNullOrEmpty(field.EventScript)) {
        const customEventFunc = eval(`(${field.EventScript})`);
        if (typeof customEventFunc === 'function') {
          customEventFunc(field, SCRIPT_ENV);
        }
      }
    } catch (ex) {
      console.log(ex)
    }

    let programContainer = getRootComponent(field);
    if (field.LovAPI) {
      programContainer.Entity = await this.getProgramContainer()
      DataUtils.assignFormValue(programContainer);
    }

    if (isSummaryLinked(field)) {
      updateFilterSelectionCode(field, field.SelectionCode);
      triggerSummaryListFilter(field);
    }

    this.props.callbackElement(programContainer);
  }

  onDropdownMultiMouseDown = async (e: any) => {
    const field = this.props.field;
    if (!field.MultipleSelectionsProps?.allowMultipleSelection) return;
    if (field.ReadOnly) return;

    const target = e?.target as HTMLElement | null;
    if (!target || (target as any).tagName !== 'OPTION') return;

    const optionEl = target as HTMLOptionElement;
    const clickedValue = optionEl.value;
    if (clickedValue === 'Select') return;

    const currentValue = Array.isArray(field.Value) ? field.Value : [];
    const isAlreadySelected = currentValue.includes(clickedValue);

    const maxRaw = field.MultipleSelectionsProps?.maxNumberOfSelection;
    const maxNumber = maxRaw != null && maxRaw !== '' ? Number(maxRaw) : null;
    const wouldExceedMax =
      !isAlreadySelected &&
      maxNumber != null &&
      !Number.isNaN(maxNumber) &&
      currentValue.length >= maxNumber;
    if (wouldExceedMax) return;

    // Keep browser selection from interfering with our toggle logic.
    e.preventDefault?.();
    e.stopPropagation?.();

    this.ignoreNextDropdownChange = true;

    field.Value = isAlreadySelected
      ? currentValue.filter((v) => v !== clickedValue)
      : [...currentValue, clickedValue];

    FormValidationUtils.markFieldDirty(field);

    try {
      FormValidationUtils.validateDropdown(field);
      FormValidationUtils.runJavascript(field);

      if (field.EventScript && Utils.isNotNullOrEmpty(field.EventScript)) {
        const customEventFunc = eval(`(${field.EventScript})`);
        if (typeof customEventFunc === 'function') {
          customEventFunc(field, SCRIPT_ENV);
        }
      }
    } catch (ex) {
      console.log(ex);
    }

    let programContainer = getRootComponent(field);
    if (field.LovAPI) {
      programContainer.Entity = await this.getProgramContainer();
      DataUtils.assignFormValue(programContainer);
    }

    if (isSummaryLinked(field)) {
      updateFilterSelectionCode(field, field.SelectionCode);
      triggerSummaryListFilter(field);
    }

    this.props.callbackElement(programContainer);
  }

  handleSearch = () => {
    const fieldAny = this.props.field as any;
    if (!fieldAny.enableSearch || !fieldAny.searchTargetSummaryListId) return;

    const root = getRootComponent(this.props.field);
    const sections = root?.ListOfFormSections ?? [];

    const findAndRefresh = (elements: any[]): boolean => {
      for (const element of elements ?? []) {
        if (element.Id === fieldAny.searchTargetSummaryListId && element._refreshData) {
          element._refreshData();
          return true;
        }
        if (element.subSectionList?.length) {
          for (const sub of element.subSectionList) {
            if (findAndRefresh(sub?.ListOfFormSectionElements)) return true;
          }
        }
      }
      return false;
    };

    for (const section of sections) {
      for (const subSection of section.ListOfFormSubSections ?? []) {
        if (findAndRefresh(subSection.ListOfFormSectionElements)) return;
      }
    }
  }

  getFieldStyle(field: FormSectionElements): any {
    let style = {};
    const viewPortSize = getViewportSize();
    if (getRootComponent(field).ErrorBottom) {
      style = { marginBottom: '4px' };
    }
    if (typeof window !== 'undefined' && viewPortSize.width > 768) {
      if (field.colWidth) {
        style = { ...style, width: field.colWidth };
      }
    } else {
      // Mobile: full width
      style = { ...style, width: '100%' };
    }
    return style;
  }


  render() {
    let field = this.props.field;
    FormValidationUtils.runJavascript(field);
    let programContainer = getRootComponent(field);
    //if (!field.Visible) return null;

    let displayfield: boolean = true;

    field.Visible = field.Visible ?? true;
    
    //Hint text
    let hint;
    const HtmlToReactParser = require('html-to-react').Parser;
    let hintHtml = this.props.isEng ? field.Hint : field.HintFR;

    const htmlToReactParser = new HtmlToReactParser();

    if (field.Hint||field.HintFR) {
        hint = htmlToReactParser.parse(hintHtml);
    }

    let editable = this.props.editable;
    let labelControlArray = this.props.labelControlArray;
    let requiredField = this.props.requiredField;
    let controlArray = [];
    let title = this.props.title;

    const lovOptions = this.applyFilter(field);

    displayfield = displayField(field);

    const requiredLabel =
      this.props.field.Optional == "N"
        ? this.props.isEng
          ? "(required)"
          : "(obligatoire)"
        : this.props.isEng
          ? "(optional)"
          : "(facultatif)";

    this.props.field.Visible = displayfield;
    if (!displayfield) return null;

    const sectionReadOnly = field.parent?.parent?.SectionReadonly === true;
    field.ReadOnly = field.ReadOnly || sectionReadOnly;

    if (field.AddEmptyItemToList == 'Y' && lovOptions.find(p => p.Sequence == 0) == null) {
      let item = new LOVValues();
      item.parent = field;
      item.Sequence = 0;
      item.code = '';
      item.description = '';
      item.FRADescription = '';
      lovOptions.unshift(item);
    }
    
    const colWidth = { width: Number(field?.colWidth) || '100%' };

    // Explicitly filtering out entries with Visible === false
    const visibleLovOptions = lovOptions.filter((option) => (option.Visible === undefined || option.Visible));
    if (editable) {
      controlArray.push(
        <div key={'div_' + field.Datatype + '_' + field.Id} id={'div_' + field.Datatype + '_' + field.Id}>

          <div key={'fdIpt_div_' + field.Id} className="ontario-form-group">
            <label
              className="ontario-label"
              style={field?.fieldSize ? { ...colWidth, fontSize: field?.fieldSize } : colWidth}
              htmlFor={field.LoadBindName}
              id={`label_${field.LoadBindName}`}
              key={"fdLbl_" + field.Id}
            >
              {title}{" "}
              {field.showOptionalLabel !== false && title ? (
                <span className="ontario-label__flag">{requiredLabel}</span>
              ) : null}
            </label>
              {hintHtml ? <p className="ontario-hint" id={`hint-text-${field.LoadBindName}`} tabIndex={field.Valid ? undefined : -1} style={field?.fieldHintSize ? { fontSize: field?.fieldHintSize } : undefined} dangerouslySetInnerHTML={{ __html: hintHtml }}></p> : null}

            {!getRootComponent(field).ErrorBottom && (<LiveValidationErrMsg
              field={this.props.field}
              isEng={this.props.isEng}
              key={"LiveValidationErrMsg_" + field.LoadBindName}
              id={`${field.LoadBindName}-${field.Id}`}
            />)}
            {field.MultipleSelectionsProps?.allowMultipleSelection && <select
              className={field.Valid ? 'ontario-input ontario-dropdown' : 'ontario-input ontario-dropdown ontario-input__error'}
              id={field.LoadBindName}
              key={'fdIpt_ontario-dropdown' + field.Id}
              style={this.getFieldStyle(field)}
              aria-readonly={field.ReadOnly}
              value={field.Value || this.props.field.Value || (visibleLovOptions.length > 0 ? [visibleLovOptions[0].code] : [])}
              onChange={this.onDropdownChangeOnDialog}
              onMouseDown={this.onDropdownMultiMouseDown}
              multiple size={field.MultipleSelectionsProps.displayListSize ? Number(field.MultipleSelectionsProps.displayListSize) : 5}>
              {visibleLovOptions.map((option, index) => (
                <option
                  key={option.code + '_' + index} // Assuming 'code' is the unique identifier for each option
                  value={option.code} // Assuming 'code' is the value for each option
                  disabled={!option.code && (field as any).hidePlaceholderFromList}
                  hidden={!option.code && (field as any).hidePlaceholderFromList}
                >
                  {this.props.isEng ? option.description : option.FRADescription}
                  {!option.code ? (this.props.isEng ? "Select" : "Sélectionner") : ""}
                </option>
              ))}
            </select>}
            {!field.MultipleSelectionsProps?.allowMultipleSelection && !((field as any).enableSearch && (field as any).searchTargetSummaryListId) && <select
              className={field.Valid ? 'ontario-input ontario-dropdown' : 'ontario-input ontario-dropdown ontario-input__error'}
              id={field.LoadBindName}
              key={'fdIpt_ontario-dropdown' + field.Id}
              style={this.getFieldStyle(field)}
              aria-readonly={field.ReadOnly}
              value={this.props.field.Value ?? (visibleLovOptions.length > 0 ? visibleLovOptions[0].code : '')}
              onChange={this.onDropdownChangeOnDialog}>
              {visibleLovOptions.map((option, index) => (
                <option
                  key={option.code + '_' + index}
                  value={option.code}
                  disabled={!option.code && (field as any).hidePlaceholderFromList}
                  hidden={!option.code && (field as any).hidePlaceholderFromList}
                >
                  {this.props.isEng ? option.description : option.FRADescription}
                  {!option.code ? (this.props.isEng ? "Select" : "Sélectionner") : ""}
                </option>
              ))}
            </select>}
            {!field.MultipleSelectionsProps?.allowMultipleSelection && (field as any).enableSearch && (field as any).searchTargetSummaryListId && (
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                <select
                  className={field.Valid ? 'ontario-input ontario-dropdown' : 'ontario-input ontario-dropdown ontario-input__error'}
                  id={field.LoadBindName}
                  key={'fdIpt_ontario-dropdown' + field.Id}
                  style={{ ...this.getFieldStyle(field), flex: 1 }}
                  aria-readonly={field.ReadOnly}
                  value={this.props.field.Value ?? (visibleLovOptions.length > 0 ? visibleLovOptions[0].code : '')}
                  onChange={this.onDropdownChangeOnDialog}>
                  {visibleLovOptions.map((option, index) => (
                    <option
                      key={option.code + '_' + index}
                      value={option.code}
                      disabled={!option.code && (field as any).hidePlaceholderFromList}
                      hidden={!option.code && (field as any).hidePlaceholderFromList}
                    >
                      {this.props.isEng ? option.description : option.FRADescription}
                      {!option.code ? (this.props.isEng ? "Select" : "Sélectionner") : ""}
                    </option>
                  ))}
                </select>
                <button
                  type="button"
                  className="ontario-button ontario-button--secondary"
                  style={{ whiteSpace: 'nowrap', flexShrink: 0, marginTop: 0, marginBottom: 0 }}
                  onClick={this.handleSearch}
                >
                  <svg className="ontario-icon" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" style={{ width: '1.25rem', height: '1.25rem' }}>
                    <use href="#ontario-icon-search"></use>
                  </svg>
                  <span style={{ marginLeft: '4px' }}>{this.props.isEng ? 'Search' : 'Rechercher'}</span>
                </button>
              </div>
            )}
            {getRootComponent(field).ErrorBottom && (<LiveValidationErrMsg
              field={this.props.field}
              isEng={this.props.isEng}
              key={"LiveValidationErrMsg_" + field.LoadBindName}
              id={`${field.LoadBindName}-${field.Id}`}
            />)}
          </div>

        </div>);
    } else {
      let descList = visibleLovOptions.filter(p => p.code == field.Value);
      controlArray.push(
        <div
          key={'fdIpt_div_' + field.Id}
          className={
            programContainer.isHorizontalLayout
              ? "pdf-row-column"
              : "pdf-two-column"
          }
        >
          <div key={'fdIpt_div2_' + field.Id}>{title}</div>
          <div key={'fdIpt_div3_' + field.Id} className={classNames({ 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField })} >
            {descList != null && descList.length > 0 ? descList[0].description : null}
          </div>
        </div>
      );
    }

    controlArray.push(<div>
      <SpinnerComponent isBusy={this.state.isBusy && getEnvVar('IS_RUNTIME') != 'false'} />
    </div>);
    return controlArray;
  }

  sortLovValues = (list: LOVValues[], isEng: boolean): LOVValues[] => {
    return [...list].sort((a, b) => {
      // Keep select option on top
      if (!a.code) return -1;
      if (!b.code) return 1;


      // Detect "Other" option
      const isOther = (opt: LOVValues) => {
        const text = isEng ? opt.description : opt.FRADescription;
        return text?.toLowerCase() === 'other' || text?.toLowerCase() === 'autre';
      };

      const aIsOther = isOther(a);
      const bIsOther = isOther(b);

      // Push "Other" to the bottom
      if (aIsOther && !bIsOther) return 1;
      if (!aIsOther && bIsOther) return -1;

      const aText = isEng ? a.description : a.FRADescription;
      const bText = isEng ? b.description : b.FRADescription;

      return (aText || '').localeCompare(bText || '', undefined, {
        sensitivity: 'base'
      });
    });
  };

  reconcilePreBoundValueWithLovOptions = (field: FormSectionElements): void => {
    const currentValue = field.Value;
    if (currentValue === undefined || currentValue === null) return;

    const currentValueTrimmed = String(currentValue).trim();
    if (currentValueTrimmed === '') return;

    const list = field.ListOfLOVValues ?? [];
    const codeMatch = list.find((opt) => String(opt?.code ?? '').trim() === currentValueTrimmed);
    if (codeMatch) return;

    const normalizedCurrentValue = currentValueTrimmed.toLowerCase();
    const descMatch = list.find((opt) => {
      const description = String(opt?.description ?? '').trim().toLowerCase();
      const fraDescription = String(opt?.FRADescription ?? '').trim().toLowerCase();
      return description === normalizedCurrentValue || fraDescription === normalizedCurrentValue;
    });

    if (descMatch) {
      field.Value = descMatch.code;
    }
  }

  applyFilter = (field: FormSectionElements): LOVValues[] => {
    const list = field.ListOfLOVValues ?? [];
    let lst: LOVValues[] = [];
    let validValue: boolean = false;
    list.forEach(opt => {
      if (!Utils.isNullOrEmpty(opt.FilterField) && !Utils.isNullOrEmpty(opt.FilterValue)
        && this.props.optionsFieldValue && this.props.optionsFieldValue.size > 0 && this.props.optionsFieldValue.has(opt.FilterField)) {
        if (this.props.optionsFieldValue.get(opt.FilterField) === opt.FilterValue) {
          if (Utils.equalsOrBothEmpty(field.Value, opt.code)) validValue = true;
          lst.push(opt);
        }
      } else {
        if (Utils.equalsOrBothEmpty(field.Value, opt.code)) validValue = true;
        lst.push(opt);
      }
    })
    const sectionReadOnly = field?.parent?.parent?.SectionReadonly === true;
    // Check for valid Lov list
    if (!validValue && ((lst.length > 0) && (lst[0].code)) && !sectionReadOnly) { 
      field.Value = null
    };
    return this.props.field.Sort ? this.sortLovValues(lst, this.props.isEng) : lst;
  }
}
